interface FormData {
  [field: string]: any;
}

const mapToBackendFormat = (form: FormData): FormData => {
  return Object.entries(form).reduce((acc, [name, value]) => {
    if (typeof value === 'boolean') value = String(Number(value));
    if (value === '') value = null;
    acc[name] = value;
    return acc;
  }, {});
};

export { mapToBackendFormat, FormData };
